import { useState } from "react";
import { EyeOff, Eye } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger, DropdownMenuCheckboxItem, DropdownMenuLabel, DropdownMenuSeparator } from "@/components/ui/dropdown-menu";
import { tx } from "@/i18n";

export const WelcomeVisibilityMenu = ({ house, onSaved }) => {
  const [hidden, setHidden] = useState({ guest: false, owner: false, ...(house.welcome_hidden || {}) });
  const save = async (key, val) => {
    const next = { ...hidden, [key]: val };
    setHidden(next);
    try {
      await api.patch(`/houses/${house.id}/welcome-visibility`, null, { params: { guest_hidden: next.guest, owner_hidden: next.owner } });
      onSaved?.(next);
      toast.success(tx("Zichtbaarheid welkomstboek opgeslagen"));
    } catch (err) { setHidden(hidden); toast.error(apiError(err)); }
  };
  const any = hidden.guest || hidden.owner;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className={`gap-1.5 ${any ? "text-primary" : "text-muted-foreground"}`} data-testid="welcome-visibility-btn">
          {any ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
          {hidden.guest && hidden.owner ? tx("Verborgen") : hidden.guest ? tx("Verborgen voor gasten") : hidden.owner ? tx("Verborgen voor eigenaren") : tx("Zichtbaarheid")}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" data-testid="welcome-visibility-menu">
        <DropdownMenuLabel className="text-xs">{tx("Verberg welkomstboek voor")}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuCheckboxItem checked={hidden.guest} onCheckedChange={(v) => save("guest", !!v)} onSelect={(e) => e.preventDefault()} data-testid="welcome-hide-guest">{tx("Gastomgeving")}</DropdownMenuCheckboxItem>
        <DropdownMenuCheckboxItem checked={hidden.owner} onCheckedChange={(v) => save("owner", !!v)} onSelect={(e) => e.preventDefault()} data-testid="welcome-hide-owner">{tx("Eigenaaromgeving")}</DropdownMenuCheckboxItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
